"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const typebox_1 = require("@sinclair/typebox");
const customTypes_1 = require("../customTypes");
exports.default = typebox_1.Type.Object({
    alwaysShow: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    bannerOptions: typebox_1.Type.Optional(customTypes_1.AppBannerOptionsObject)
});
